import React from 'react';
import PropTypes from 'prop-types';
import ReactTooltip from 'react-tooltip';
import { OptionButton } from 'AppSrc/core/components/utility/option-button';
import { formDataShape } from 'AppSrc/core/components/forms/form-base-components/data-structure/v-f-proptypes';
import { CircleCross } from 'AppSrc/core/components/common/svg-icons';
import {
  RELATIONSHIP_TYPE,
  // RELATIONSHIP_FIELD_BY_TYPE,
  CONFIGURATION_ITEM_UA_SCHEDULED_START_DATE,
  CONFIGURATION_ITEM_UA_SCHEDULED_END_DATE,
  RELATIONSHIP_HOW_RELATED,
  RT_CI_UNAVAILABILITY,
  CONFIGURATION_ITEM, // importing here for all relationships type for ci defect
  PROJECT_CODE,
  INCIDENT_REFERENCE,
} from 'AppSrc/core/components/forms/form-types/create-crq/relationships/relationships-modal/relationship-constants';
import 'AppSrc/core/style/components/form/form-base-components/summary-components/modal-summary/relationships-summary.css';
import {
  MOBILE,
  // RT_CONFIGURATION_ITEM,
  // RT_PROJECT_CODE,
  // RT_INCIDENT,
} from 'AppSrc/core/components/forms/value-dependency-constants';
import { getTimezoneForNetwork } from 'AppSrc/core/utility-functions/date-functions';
import moment from 'moment-timezone';
import { SUMMARY_SECTION_V_F_MODAL } from './modal-summary-constants';

const mobileTimezone = getTimezoneForNetwork(MOBILE);

const getRelationshipTypeDisplay = (typeValue) => (typeValue);

// we are bypassing the fixed types for ci defct as we are getting every thing in type value.

// const typeDisplay = {
//   [RT_CONFIGURATION_ITEM]: 'CI',
//   [RT_PROJECT_CODE]: 'Project Code',
//   [RT_INCIDENT]: 'Incident',
//   // CI unavailabilities should show up in the summary
//   // event though they can not be created directly
//   [RT_CI_UNAVAILABILITY]: 'CI Unavailability',
// }[typeValue];
// if (!typeDisplay) {
//   console.warn(`Could not find a display value for relationship type ${typeValue}`);
//   return '-';
// }
//   typeValue;
// );

const getDateTypeDisplay = (date) => {
  if (!date) { return '--/--/--'; }
  const dateMoment = moment.tz(date, mobileTimezone);
  const timeZone = dateMoment.format('z');
  const dateString = dateMoment.format('DD/MM/YYYY HH:mm');
  return `${dateString} (${timeZone})`;
};

const getSectionDataFieldValue = (sectionData, fieldId) => {
  const field = sectionData.dataByFieldId[fieldId];
  return field ? field.value : null;
};

const RelationshipsSummary = React.memo(({
  modalData,
  editItem,
  deleteItem,
  displayType,
  selectedNetwork,
  formData,
}) => {


  const {
    formSectionsByDisplayOrder,
    dataByFormSectionId,
  } = modalData;



  const dataMap = formSectionsByDisplayOrder.map((sectionId, i) => dataByFormSectionId[sectionId]);
  const summaryPageView = displayType === SUMMARY_SECTION_V_F_MODAL;
  // don't render the table in the summary view if there are no items
  if (summaryPageView && dataMap.length === 0) {
    return null;
  }

  return (
    <div className={`relationship-summary relationship-summary-${summaryPageView ? 'summary-page' : 'standard'} vf-table`}>
      <div className="vf-table-head-container">
        <div
          className="vf-table-head"
        >
          <div className="start-date start-date-head head-item">
            <span className="head-text">
              Start Date
            </span>
          </div>

          <div className="end-date end-date-head head-item">
            <span className="head-text">
              End Date
            </span>
          </div>
          <div className="relationship name-head head-item">
            <span className="head-text">
              Name
            </span>
          </div>
          <div className="type type-head head-item">
            <span className="head-text">
              Type
            </span>
          </div>
          <div className="relationship relationship-head head-item">
            <span className="head-text">
              Relationship
            </span>
          </div>
          <div className="status status-head head-item">
            <span className="head-text">
              Status
            </span>
          </div>
        </div>
      </div>

      {
        dataMap.map((sectionData, index) => {
          const { sectionId, relationshipId } = sectionData;
          let relationshipFieldId = CONFIGURATION_ITEM; // assigning here for ci defect.
          let relationshipTypeValue = getSectionDataFieldValue(sectionData, relationshipFieldId);
          if (relationshipTypeValue === null) {
            relationshipTypeValue = getSectionDataFieldValue(sectionData, RELATIONSHIP_TYPE);
          }
          // const relationshipFieldId = RELATIONSHIP_FIELD_BY_TYPE[relationshipTypeValue];
          // const relationshipFieldId = CONFIGURATION_ITEM; // assigning here for ci defect.

          const relationshipTypeDisplay = getRelationshipTypeDisplay(relationshipTypeValue);
          if (relationshipTypeDisplay === 'AST:Project') {
            relationshipFieldId = PROJECT_CODE;
          }
          if (relationshipTypeDisplay === 'HPD:Help Desk') {
            relationshipFieldId = INCIDENT_REFERENCE;
          }

          const relationshipValue = getSectionDataFieldValue(sectionData, relationshipFieldId);

          const startDateValue = getSectionDataFieldValue(sectionData, CONFIGURATION_ITEM_UA_SCHEDULED_START_DATE);
          const endDateValue = getSectionDataFieldValue(sectionData, CONFIGURATION_ITEM_UA_SCHEDULED_END_DATE);
          const howRelatedValue = getSectionDataFieldValue(sectionData, RELATIONSHIP_HOW_RELATED);

          // not all fields have a start and end date
          const formattedStartDate = getDateTypeDisplay(startDateValue);
          const formattedEndDate = getDateTypeDisplay(endDateValue);

          const name = relationshipValue && relationshipValue.name ? relationshipValue.name : '-';
          const status = relationshipValue && relationshipValue.status ? relationshipValue.status : '-';
          const relationship = howRelatedValue ? howRelatedValue : '-';
          // const newrelationshipValue = relationshipTypeDisplay && relationshipTypeDisplay.referenceType ? relationshipTypeDisplay.referenceType : '-';
          const newrelationshipValue = relationshipValue && relationshipValue.referenceType ? relationshipValue.referenceType : '-';
          const alertOptions = {
            option: sectionId,
          };

          // existing relationships can not be edited, unless they are CI Unavailability
          const isCiUnavailability = relationshipTypeValue === RT_CI_UNAVAILABILITY;
          const editableRelationship = isCiUnavailability || !relationshipId;
          const canEdit = !summaryPageView && editableRelationship;
          return (
            <div
              className="vf-table-row-container"
              key={sectionId}
            >
              <div
                className="vf-table-row"
              >
                <div
                  className="row-with-cols"
                >
                  <OptionButton
                    type="button"
                    className="row-button"
                    onClick={editItem}
                    option={sectionId}
                    disabled={!canEdit}
                  >
                    <div className="start-date start-date-row row-item">
                      <span className="row-item-text">
                        {formattedStartDate}
                      </span>
                    </div>
                    <div className="end-date end-date-row row-item">
                      <span className="row-item-text">
                        {formattedEndDate}
                      </span>
                    </div>
                    <div className="relationship name-row row-item">
                      <span data-tip={name} className="row-item-text">
                        {name}
                      </span>
                    </div>
                    <div className="type type-row row-item">
                      <span data-tip={newrelationshipValue} className="row-item-text">
                        {newrelationshipValue}
                      </span>
                    </div>
                    <div className="relationship relationship-row row-item">
                      <span className="row-item-text">
                        {relationship}
                      </span>
                    </div>
                    <div className="status status-row row-item">
                      <span className="row-item-text">
                        {status}
                      </span>
                    </div>
                  </OptionButton>
                  {!summaryPageView && (
                    <OptionButton
                      type="button"
                      className="delete-item row-action"
                      onClick={deleteItem}
                      option={alertOptions}
                    >
                      <div className="svg-wrapper">
                        <CircleCross />
                      </div>
                    </OptionButton>
                  )}
                </div>
              </div>
            </div>
          );
        })
      }
      <ReactTooltip />
    </div>
  );
});


RelationshipsSummary.propTypes = {
  formData: formDataShape,
  modalData: formDataShape,
  editItem: PropTypes.func,
  deleteItem: PropTypes.func,
  displayType: PropTypes.string,
  selectedNetwork: PropTypes.string,
};

const RELATIONSHIPS_SUMMARY = 'RELATIONSHIPS_SUMMARY';

export {
  RelationshipsSummary,
  RELATIONSHIPS_SUMMARY,
};

